import { URL_API } from '../../../../services/api_url'
import CreateCompany from '../../../../pages/Companies/CreateCompany'
import { RemoteCreateCompany } from '../../../../data/usecases/Company/RemoteCreateCompany'
import { RemoteEditCompany } from '../../../../data/usecases/Company/RemoteEditCompany'
import { useAxiosHttpClient } from '../../../../hooks/useAxiosHttpClient'

export const CompanyCreateFactory = () => {
  const URL = URL_API || 'without-url'
  const axiosHttpClient = useAxiosHttpClient()
  const remoteCreateCompany = new RemoteCreateCompany(URL, axiosHttpClient)
  const remoteEditCompany = new RemoteEditCompany(URL, axiosHttpClient)

  return (
    <CreateCompany
      handleCreateCompany={remoteCreateCompany}
      handleUpdateCompany={remoteEditCompany}
    />
  )
}
